import type { SVGProps } from "react";

export const Yugabytedb = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="currentColor"
    viewBox="0 0 39 35"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Yugabytedb</title>
    <path d="M10.27,0c0.88,0,1.31,0,1.65,0.17c0.29,0.15,0.53,0.39,0.68,0.68c0.17,0.33,0.17,0.77,0.17,1.65v10.99c0,1.3,0,1.96-0.27,2.36c-0.24,0.35-0.61,0.59-1.03,0.66c-0.48,0.08-1.07-0.2-2.25-0.75l-3.08-1.44c-2.22-1.04-3.33-1.56-4.15-2.36c-0.72-0.71-1.27-1.57-1.61-2.52C0,8.37,0,7.15,0,4.69V2.5c0-0.88,0-1.31,0.17-1.65c0.15-0.29,0.39-0.53,0.68-0.68C1.19,0,1.63,0,2.5,0H10.27z" />
    <path d="M35.82,0c0.88,0,1.31,0,1.65,0.17c0.29,0.15,0.53,0.39,0.68,0.68c0.17,0.33,0.17,0.77,0.17,1.65v2.19c0,2.45,0,3.68-0.38,4.76c-0.34,0.95-0.89,1.81-1.61,2.52c-0.81,0.8-1.93,1.32-4.15,2.36l-6.64,3.09V2.5c0-0.88,0-1.31,0.17-1.65c0.15-0.29,0.39-0.53,0.68-0.68C26.73,0,27.17,0,28.05,0H35.82z" />
    <path d="M25.54,17.42v14.92c0,0.88,0,1.31-0.17,1.65c-0.15,0.29-0.39,0.53-0.68,0.68c-0.33,0.17-0.77,0.17-1.65,0.17h-7.77c-0.88,0-1.31,0-1.65-0.17c-0.29-0.15-0.53-0.39-0.68-0.68c-0.17-0.33-0.17-0.77-0.17-1.65v-2.2c0-2.45,0-3.68,0.38-4.76c0.34-0.95,0.89-1.81,1.61-2.52c0.81-0.8,1.93-1.32,4.15-2.35L25.54,17.42z" />
  </svg>
);

export default Yugabytedb;
